import { SEARCH_TERM, TEXT_SEARCH } from '../constants';
import parseFilterValue from './parse-filter-value';
import { buildQueryKey } from '../../../helpers';
const buildUrlQuery = (filterValues = {}, filters = [], listComponentName = '', query = {}) => {
  const newQuery = [];
  const queryKeys = [];
  const searchValue = filterValues[SEARCH_TERM];
  const searchKey = buildQueryKey(SEARCH_TERM, listComponentName);
  queryKeys.push(searchKey);
  if (searchValue) newQuery.push(`${searchKey}=${searchValue}`);
  filters.forEach(({
    propsToDisplay,
    type
  }) => {
    if (type === TEXT_SEARCH) return;
    propsToDisplay.forEach(prop => {
      const value = filterValues[prop];
      const filterKey = buildQueryKey(prop, listComponentName);
      queryKeys.push(filterKey);
      const parsedValue = parseFilterValue(filterKey, type, value, newQuery);
      if (parsedValue && !newQuery.includes(parsedValue)) newQuery.push(parsedValue);
    });
  });
  Object.keys(query).forEach(key => {
    if (queryKeys.indexOf(key) !== -1) return;
    let shouldAdd = true;
    if (!listComponentName) {
      shouldAdd = !key.endsWith('[page]');
    } else {
      shouldAdd = !key.includes(listComponentName);
    }
    if (shouldAdd) newQuery.push(`${key}=${query[key]}`);
  });
  return newQuery.join('&');
};
export default buildUrlQuery;
//# sourceMappingURL=build-url-query.js.map